import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LogOut, LogIn } from 'lucide-react';
import { Button, Container } from '@easymoving/ui';
import { LanguageSwitcher } from './LanguageSwitcher';
import { useAuth } from '../context/AuthContext';

export function TopNav() {
  const { t } = useTranslation();
  const { user, signOut } = useAuth();

  async function onSignOut() {
    await signOut();
    // Full navigation: `/` is the static landing site, outside the SPA.
    window.location.assign('/');
  }

  return (
    <header className="print:hidden sticky top-0 z-30 border-b hairline bg-bg/85 backdrop-blur-md">
      <Container className="flex h-16 items-center justify-between gap-4">
        {user ? (
          <Link to="/app" className="flex items-center gap-2.5">
            <img src="/easymoving-mark.svg" alt="" className="size-8" />
            <span className="font-display text-lg tracking-snug">{t('brand.name')}</span>
          </Link>
        ) : (
          /* signed out → the static landing site (full navigation) */
          <a href="/" className="flex items-center gap-2.5">
            <img src="/easymoving-mark.svg" alt="" className="size-8" />
            <span className="font-display text-lg tracking-snug">{t('brand.name')}</span>
          </a>
        )}
        <div className="flex items-center gap-2">
          <LanguageSwitcher />
          {user ? (
            <Button
              variant="ghost"
              size="sm"
              onClick={onSignOut}
              aria-label={t('nav.signOut')}
              title={t('nav.signOut')}
            >
              <LogOut className="size-4" />
              <span className="hidden sm:inline">{t('nav.signOut')}</span>
            </Button>
          ) : (
            <Button asChild variant="ghost" size="sm">
              <Link to="/login" aria-label={t('nav.signIn')} title={t('nav.signIn')}>
                <LogIn className="size-4" />
                <span className="hidden sm:inline">{t('nav.signIn')}</span>
              </Link>
            </Button>
          )}
        </div>
      </Container>
    </header>
  );
}
